(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bfbella-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const buyNowButton = event.target instanceof Element
      ? event.target.closest('[data-bfbella-buy-now]')
      : null;
    if (buyNowButton) {
      window.__bfbellaBuyNowArmed = true;
    }
  });

  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (cartEvent) => {
      if (window.__bfbellaBuyNowArmed && cartEvent.action === 'add') {
        window.__bfbellaBuyNowArmed = false;
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
